import React, { useEffect, useState } from "react";
import ShowImage from "../ShowImage";

const RoomCard = ({ room }) => {
  const [exist, setExist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [available, setAvailable] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/roombook`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return setExist(data), setLoading(false);
      });
  }, []);

  return (
    <div>
      <div className="card mb-3 roombox">
        <ShowImage item={room} url="home" />
        <div className="card-body">
          <h5 className="card-title">{room.name}</h5>
          {exist.map(
            (data) =>
              data.roomimgid === room._id && (
                <h2 className="text-danger">Booked</h2>
              )
          )}
          <p className="card-text">{room.description}</p>
          <p className="text-muted">
            <img
              src="https://img.icons8.com/color/35/000000/key-exchange.png"
              alt="icon"
            />{" "}
            Price: INR {room.price} /Month
          </p>
          <p className="text-muted">
            {" "}
            <img
              src="https://img.icons8.com/fluent/25/000000/walking.png"
              alt="icon"
            />
            {room.distance && `${room.distance}`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RoomCard;
